import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\faq-page\\components\\FAQInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\app\\homepage\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\laragon\\www\\surilipat-hub\\frontend\\src\\components\\common\\Header.tsx");
